import { useState } from "react";
import { useOutletContext } from "react-router";
import Encarte from "../../../OBJRep/Encarte";
import Button from "../../sharable/ActionButton";
import Logo from "../../sharable/Logo";
import Notification from "../../sharable/Notification";
import useCreateEncarte from "../../sharable/hooks/useCreateEncarte";
import { Container, Content, MediaGrid } from "./Upsell.styles";

const SERVICES = [
  {
    id: "video-1",
    type: "Video",
    title: "Vídeos - Linha Essencial",
    description:
      "Coloque suas ofertas em destaque com vídeos promocionais produzidos especialmente para o varejo. 🚨 ",
    price: "R$ 69,99",
    mediaUrl: "https://www.youtube-nocookie.com/embed/2XpAjPIU06E",
  },
  {
    id: "video-2",
    type: "Video",
    title: "Vídeos - Linha Destaque",
    description:
      "Coloque suas ofertas em destaque com vídeos promocionais produzidos especialmente para o varejo. 🚨 ",
    price: "R$ 139,99",
    mediaUrl: "https://www.youtube-nocookie.com/embed/HZq9W6T8mhE",
  },
  {
    id: "audio-1",
    type: "Audio",
    title: "Spot para mídia de rua",
    description:
      "Spot para rodar no carro de som fazer toda sua cidade correr para sua loja.",
    price: "R$ 44,99",
    mediaUrl: "https://www.youtube-nocookie.com/embed/RIylhSFWb6g",
  },
  {
    id: "audio-2",
    type: "Audio",
    title: "Spot para porta de loja",
    description:
      "Spot para rodar na porta da sua loja para chamar quem está em frente a loja e atrair mais clientes.",
    price: "R$ 54,99",
    mediaUrl: "https://www.youtube-nocookie.com/embed/bI3KDV2DHKY",
  },
  {
    id: "curso-1",
    type: "Curso",
    title: "Curso Turbinando no Instagram",
    description:
      "Se você é leigo em como utilizar o seu instagram e turbinar suas postagens, este curso é para você.",
    price: "R$ 49,99",
    mediaUrl: "https://www.youtube-nocookie.com/embed/UBCXu2DK0qg",
    checkoutUrl: "https://pay.kiwify.com.br/lTBv1Vd",
  },
];

const WHATSAPP_PHONE = process.env.REACT_APP_WHATSAPP_PHONE;

const getServiceWhatsappLink = (service, user) => {
  const message = `Olá, meu nome é ${user?.name}, meu email é ${user?.email}. Tenho interesse no serviço "${service.title}" (${service.price}).`;
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
};

const getServiceBuyLink = (service, user) =>
  service.checkoutUrl || getServiceWhatsappLink(service, user);

export default function Upsell() {
  const { token, user } = useOutletContext();
  const [notification, setNotification] = useState(null);
  const { createEncarte } = useCreateEncarte({ token, setNotification });

  const handleCreateEncarte = async () => {
    try {
      await createEncarte(Encarte());
    } catch (err) {
      setNotification({
        message: "Nao foi possivel criar o encarte agora.",
        type: "error",
      });
    }
  };

  return (
    <Container>
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          autoHide={true}
          onClose={() => setNotification(null)}
        />
      )}

      <header>
        <Logo showGoBackButton={true} path="/encartes" className="logo" />
      </header>

      <Content>
        <h1>Sua divulgação ainda mais completa</h1>
        <p className="intro">
          Confira conteúdos extras para potencializar seus resultados.
        </p>

        <MediaGrid>
          {SERVICES.map((service) => (
            <article className="card" key={service.id}>
              <span className="badge">{service.type}</span>
              <h2>{service.title}</h2>
              <p className="description">{service.description}</p>

              <iframe
                className="embed"
                src={service.mediaUrl}
                title={service.title}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />

              <div className="price-wrap">
                <span className="price-label">A partir de</span>
                <span className="price-value">{service.price}</span>
              </div>

              <a
                className="buy-link"
                href={getServiceBuyLink(service, user)}
                target="_blank"
                rel="noreferrer"
              >
                Comprar agora
              </a>
            </article>
          ))}
        </MediaGrid>
        <p className="cta-message">
          Obrigado pela compra, você pode criar seu encarte agora.
        </p>
        <div className="cta-wrap">
          <Button
            action={handleCreateEncarte}
            text="Criar encarte agora"
            width="30rem"
          />
        </div>
      </Content>
    </Container>
  );
}
